import React from "react";

import Image from "next/image";

import { Box, Container, Hidden, Typography } from "@mui/material";

import HeroImageDesktop from "../../../public/static/home/hero_desktop.png";
import BannerFrame from "../../../public/static/home/hero_frame_desktop.png";
import HeroGretaImageDesktop from "../../../public/static/home/hero_greta_desktop.png";
import HeroGretaImageMobile from "../../../public/static/home/hero_greta_mobile.png";
import LogoImage from "../../../public/static/home/hero_logo_desktop.png";
import HeroImageMobile from "../../../public/static/home/hero_mobile.png";

const HomeHero = (props) => (
  <Box
    sx={{
      backgroundColor: "background.paper",
      pt: { xs: 0, sm: 6 },
      pb: 2,
    }}
    {...props}
  >
    <Container maxWidth="lg" sx={{ width: "100%" }}>
      <Box sx={{ display: { xs: "none", sm: "block" }, position: "relative" }}>
        <Image
          alt=""
          src={HeroImageDesktop}
          layout="responsive"
          placeholder="empty"
          priority
        />
        <Box
          style={{
            top: 0,
            position: "absolute",
            width: "100%",
          }}
        >
          <Image
            alt=""
            src={HeroGretaImageDesktop}
            layout="responsive"
            placeholder="empty"
          />
        </Box>
        <Box
          style={{
            top: 0,
            width: "100%",
          }}
        >
          <Box
            style={{
              top: 0,
              bottom: 0,
              display: "flex",
              flexDirection: "row",
              left: "4%",
              position: "absolute",
              width: "35%",
            }}
          >
            <Hidden mdDown>
              <Image alt="" src={BannerFrame} placeholder="blur" />
            </Hidden>
          </Box>
          <Box
            sx={{
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
              top: { sm: "8%", md: "21%", lg: "23%" },
              left: { sm: "5%", md: "10%" },
              position: "absolute",
              width: { sm: "38%", md: "23%" },
            }}
          >
            <Box sx={{ width: { sm: "20vw", md: "60%", lg: "90%" } }}>
              <Image
                alt="創作者事務所"
                src={LogoImage}
                placeholder="empty"
                priority
              />
            </Box>
            <Typography
              sx={{
                maxWidth: { sm: "200px", md: "100vw" },
                color: {
                  sm: "primary.contrastText",
                  md: "primary.main",
                },
                textAlign: "center",
                fontSize: { lg: 20 },
              }}
            >
              飛天奶茶有系統地整合來自世界各地的專業創作者資源，擔當企業與創作者之間溝通的橋樑，致力於為各界企業量身訂製最佳的多元化創意內容，可用於品牌推廣、商品宣傳、產品包裝、遊戲製作等等。
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box sx={{ display: { xs: "block", sm: "none" } }}>
        <Box
          sx={{
            position: "relative",
            mx: -2,
          }}
        >
          <Image
            alt=""
            src={HeroImageMobile}
            layout="responsive"
            placeholder="empty"
            priority
          />
          <Box
            style={{
              bottom: 0,
              position: "absolute",
              width: "100%",
            }}
          >
            <Image
              alt=""
              src={HeroGretaImageMobile}
              layout="responsive"
              placeholder="empty"
            />
          </Box>
        </Box>
        <Box sx={{ pt: 2, pb: 6 }}>
          <Typography fontSize={16} variant="subtitle1">
            飛天奶茶有系統地整合來自世界各地的專業創作者資源，擔當企業與創作者之間溝通的橋樑，致力於為各界企業量身訂製最佳的多元化創意內容，可用於品牌推廣、商品宣傳、產品包裝、遊戲製作等等。
          </Typography>
        </Box>
      </Box>
    </Container>
  </Box>
);

export default HomeHero;
